import { call, put } from 'redux-saga/effects';
import AuthorizedUserDTO from '../../../dto/AuthorizedUserDTO';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { authorizedLoginFailed, authorizedLoginSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* authorizedLogin(action) {
  try {
    // todo need refact client model and this code
    const client = new AuthorizedUserDTO(action.payload);
    const url = `${BACKEND_URL}/auth/login`;
    const pool = client.getLoginData();
    const userDataResponse = yield makeRequest(url, pool, action);
    const authorizedData = yield userDataResponse.json();
    if (
      userDataResponse
      && userDataResponse.status === OK
      && authorizedData
      && authorizedData.data
      && authorizedData.data.token
    ) {
      window.localStorage.clear();
      yield put(authorizedLoginSuccessful(authorizedData.data));
      yield call(resolveActionPromise(action, authorizedData.data));
    } else {
      yield put(authorizedLoginFailed());
      yield call(rejectActionPromise(action, authorizedData.error));
    }
  } catch (e) {
    yield put(authorizedLoginFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
